import React from "react";
import ReactDateTime from "react-datetime";
import { fieldPropTypes } from "redux-form/lib/propTypes";
import moment from "../../lib/moment";

const inputFormat = "YYYY-MM-DD HH:mm";
const displayFormat = "D MMMM YYYY HH:mm";

class DatePicker extends React.Component {
  static propTypes = {
    ...fieldPropTypes
  };

  onChange = value => {
    const { input } = this.props;
    input.onChange(moment.isMoment(value) ? value.format(inputFormat) : value);
  };

  onClear = () => {
    this.onChange("");
  };

  isValidDate = current => {
    const { deliveryDate } = this.props;
    const startOfDay = moment(deliveryDate).startOf("day");
    return current.isSame(startOfDay) || current.isAfter(startOfDay);
  };

  renderInput = (props, openCalendar) => {
    const { input, placeholder } = this.props;
    let { value } = input;
    if (value !== moment(value).format(inputFormat)) {
      value = null;
    }
    return (
      <div
        className="SchemaField__DatePicker__Input form-control-display"
        onClick={openCalendar}
        role="button"
        tabIndex="-1"
        onKeyDown={openCalendar}
      >
        <i className="fa fa-calendar mr-1" />
        &nbsp;
        {(value && (moment.isMoment(value) ? value : moment(value)).format(displayFormat)) || placeholder}
        <div className="SchemaField__DatePicker__Actions">
          {value && (
            <i className="fa fa-times" onClick={this.onClear} role="button" tabIndex="-1" onKeyDown={this.onClear} />
          )}
        </div>
        <input {...input} type="hidden" />
      </div>
    );
  };

  render() {
    const { input, placeholder, deliveryDate } = this.props;
    const now = ReactDateTime.moment();

    // eslint-disable-next-line prefer-destructuring
    let value = input.value;
    if (value !== moment(value).format(inputFormat)) {
      value = null;
    }

    return (
      <div className="SchemaField__DatePicker">
        <ReactDateTime
          closeOnSelect
          viewMode="days"
          locale={moment.locale()}
          isValidDate={this.isValidDate}
          inputProps={{ placeholder }}
          value={
            value && !moment.isMoment(value)
              ? moment(value)
              : moment(deliveryDate || null)
                  .set("hours", now.hours())
                  .set("minutes", now.minutes())
          }
          onChange={this.onChange}
          onFocus={this.onFocus}
          renderInput={this.renderInput}
        />
      </div>
    );
  }
}

export default DatePicker;
